import React, { useMemo } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import MoreMenu from "@/components/MoreMenu";

const useNissanColorsTableColumns = ({ onMenuItemClick }) => {
  return useMemo(
    () => [
      {
        title: "Year",
        dataIndex: "year",
        render: text => {
          return <span className="span-click">{text}</span>;
        },
      },
      {
        title: "Code",
        dataIndex: "code",
        render: text => {
          return <span className="span-click">{text}</span>;
        },
      },
      {
        title: "Description",
        dataIndex: "description",
        render: text => {
          return <span className="span-click">{text}</span>;
        },
      },
      {
        title: "",
        dataIndex: "moreMenu",
        render: (text, record) => {
          return (
            <span>
              <MoreMenu
                onItemClick={key => onMenuItemClick(key, record)}
                items={[
                  {
                    key: "delete",
                    icon: <DeleteOutlined />,
                    label: "Delete",
                    authority: "NissanService.Colors.Delete",
                  },
                  {
                    key: "edit",
                    icon: <EditOutlined />,
                    label: "Edit",
                    authority: "NissanService.Colors.Edit",
                  },
                ]}
              />
            </span>
          );
        },
      },
    ],
    [onMenuItemClick],
  );
};

export default useNissanColorsTableColumns;
